var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.1875em",
    height: "0.875em",
    viewBox: "0 0 19 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav-/-768-/-Dashboard",
    transform: "translate(-623.000000, -29.000000)",
    fill: "#B45CB0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(618.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(14.500000, 13.000000) rotate(-315.000000) translate(-14.500000, -13.000000) translate(8.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(-0.000095, -0.000048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5509091,9.872048 C11.4163636,12.272048 9.0766,13.760048 6.45272727,13.760048 C4.75090909,13.760048 3.12023636,13.088048 1.89090909,11.960048 L1.89090909,14.000048 L4.54747351e-13,14.000048 L4.54747351e-13,8.240048 L5.38909091,8.240048 L5.38909091,10.160048 L2.78909091,10.160048 C3.71114545,11.216048 5.05818182,11.840048 6.45272727,11.840048 C8.34363636,11.840048 10.0220545,10.760048 10.8493273,9.032048 L11.2509091,8.168048 L12.9527273,9.008048 L12.5509091,9.872048 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.433379731,4.104 C1.63708343,1.8 3.97226862,0.384 6.57226862,0.384 C8.13708343,0.384 9.62967603,0.912 10.8333797,1.848 L10.8333797,-2.27373675e-13 L12.7593057,-2.27373675e-13 L12.7593057,4.08 L12.8074538,4.128 L12.7593057,4.152 L12.7593057,5.52 L7.43917603,5.52 L7.43917603,3.6 L9.91856492,3.6 C9.00399084,2.784 7.82412047,2.304 6.57226862,2.304 C4.69449084,2.304 3.00930566,3.336 2.14263899,4.992 L1.70930566,5.856 L4.63973065e-05,4.968 L0.433379731,4.104 Z",
    id: "Fill-4"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchIcon);
export default __webpack_public_path__ + "static/media/switchIcon.fbf1c303ed23d8f7e94141caadebb54b.svg";
export { ForwardRef as ReactComponent };